// 時段菜單：依 GoodsCategoryTimeSlots_list 判斷分類在某個時間點是否顯示。
// startMinute / endMinute 為當日第幾分鐘（0~1439），start > end 代表跨日。

export const getMinuteOfDay = (date = new Date()) => date.getHours() * 60 + date.getMinutes()

// "HH:mm" → 當日第幾分鐘；格式不符回傳 null（例：零售自取 pickupTime 為 null）
export const parseTimeToMinute = (time) => {
    const match = /^(\d{1,2}):(\d{1,2})$/.exec(String(time ?? '').trim())
    if (!match) return null
    const hour = Number(match[1])
    const minute = Number(match[2])
    if (hour > 23 || minute > 59) return null
    return hour * 60 + minute
}

const toMinute = (value) => {
    if (value === null || value === undefined || value === '') return null
    const minute = Number(value)
    return Number.isFinite(minute) ? minute : null
}

// 同日區間 [start, end)；跨日為 [start, 24:00) ∪ [00:00, end)；start === end 視為全天
export const isMinuteInSlot = (slot, minute) => {
    const { startMinute, endMinute } = slot
    if (startMinute === endMinute) return true
    if (startMinute < endMinute) return minute >= startMinute && minute < endMinute
    return minute >= startMinute || minute < endMinute
}

// 時段清單 → { [goodsCategoryId]: [{ startMinute, endMinute }] }，濾掉不合法的資料
export const groupTimeSlotsByCategory = (slots) => {
    if (!Array.isArray(slots)) return {}
    return slots.reduce((map, slot) => {
        const categoryId = slot?.goodsCategoryId
        const startMinute = toMinute(slot?.startMinute)
        const endMinute = toMinute(slot?.endMinute)
        if (!categoryId || startMinute === null || endMinute === null) return map
        if (!map[categoryId]) map[categoryId] = []
        map[categoryId].push({ startMinute, endMinute })
        return map
    }, {})
}

// 沒有時段設定 → 全天顯示；有多筆時段 → 符合任一筆即顯示
export const isCategoryAvailableAt = (slotMap, categoryId, minute) => {
    const slots = slotMap?.[categoryId]
    if (!slots || !slots.length) return true
    return slots.some(slot => isMinuteInSlot(slot, minute))
}
